import React from "react";
import { AuthProvider } from "./AuthProvider.mjs";
import { ContactInfoProvider } from "./ContactInfoProvider.mjs";
import { ContactUpdateTranslationsProvider } from "./ContactUpdateTranslationsProvider.mjs";
import { InvoiceProvider } from "./InvoiceProvider.mjs";
import { API } from "../util/ApiUtil.mjs";
import { getWebCommonApiUrl } from "../util/UrlUtil.mjs";
const MainProvider = (props) => {
  const { children, auth, lang, tier } = props;
  const commonApi = API(getWebCommonApiUrl(props.tier), { withCredentials: true, timeout: 2e4 });
  return /* @__PURE__ */ React.createElement(ContactUpdateTranslationsProvider, { ...props }, /* @__PURE__ */ React.createElement(AuthProvider, { auth }, /* @__PURE__ */ React.createElement(InvoiceProvider, { commonApi }, /* @__PURE__ */ React.createElement(ContactInfoProvider, { commonApi, lang, tier }, children))));
};
export {
  MainProvider as default
};
